import type { SVGProps } from 'react';

export function WiltedIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.3 1.2c2.486 0 4.5 2.014 4.5 4.5v.232c1.099.458 1.8 1.55 1.8 2.884 0 1.046-.949 2.805-2.475 4.189a.77.77 0 0 1-.525.199.77.77 0 0 1-.525-.199c-1.526-1.38-2.475-3.139-2.475-4.189 0-1.335.701-2.426 1.8-2.884V5.7c0-1.159-.941-2.1-2.1-2.1s-2.1.941-2.1 2.1v15.9a1.199 1.199 0 1 1-2.4 0V10.5c0-1.159-.941-2.1-2.1-2.1s-2.1.941-2.1 2.1v1.432c1.099.458 1.8 1.55 1.8 2.884 0 1.047-.949 2.805-2.475 4.189a.77.77 0 0 1-.525.199.77.77 0 0 1-.525-.199C3.349 17.621 2.4 15.863 2.4 14.816c0-1.339.701-2.426 1.8-2.884V10.5C4.2 8.014 6.214 6 8.7 6c.757 0 1.474.187 2.1.517V5.7c0-2.486 2.014-4.5 4.5-4.5" />
    </svg>
  );
}
